import { useContext } from "react";
import RouterContext from "../libs/router/Router";
export default function useRouterContext() {
    const { state, setState } = useContext(RouterContext);
    return [state, setState];
}
